"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const RemoveAssignmentsButton_1 = require("../../../elements/RemoveAssignmentsButton");
function SignalAssignmentsColumn({ row, onHover, assignment, highlight, onLink, onUnlink, }) {
    const diaIDs = (0, get_1.default)(row, 'tableMetaInfo.signal.diaIDs', []);
    const tdCss = assignment.isActive || highlight.isActive
        ? {
            color: 'red',
            fontWeight: 'bold',
        }
        : {};
    function assignHandler(e) {
        onLink?.(e, assignment);
    }
    return ((0, jsx_runtime_1.jsx)("td", { ...onHover, onClick: assignHandler, style: { padding: '0', ...tdCss }, css: !assignment.isActive && RemoveAssignmentsButton_1.removeAssignmentCssStyle, children: (diaIDs?.length > 0 || assignment.isActive) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: diaIDs?.length || 0 }), (0, jsx_runtime_1.jsx)(RemoveAssignmentsButton_1.RemoveAssignmentsButton, { onClick: (e) => onUnlink?.(e, false) })] })) }));
}
exports.default = (0, react_1.memo)(SignalAssignmentsColumn);
